import React, { useState, useEffect, useContext } from "react";
import { languageContext } from "../../../config/language";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import { SelectMultipleContainer } from "./styles";

interface Props {
  filter_code: string;
  placeholder: string;
  optionList: any[];
  dataItemKey: string;
  optionName: string;
  inputId: string;
  values: any[]; //selectedValues
  handleChange: (updatedList: any[]) => void;
  disabled: boolean;
  loading?: boolean;
  dataCy?: string
}

export default (props: Props) => {
  const { languageContext: lang } = useContext(languageContext);

  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    const optionList = props.optionList || [];
    setData(optionList);
  }, [props.optionList]);

  const handleChange = (event: any) => {
    props.handleChange(event.target.value);
  };

  const filterChange = (event: any) => {
    if (!event.filter.value.trim()) {
      setData(props.optionList || []);
    } else {
      const dataFiltered = filterBy(props.optionList, event.filter);
      setData(dataFiltered);
    }
  };

  const selected = props.values.length;
  return (
    <SelectMultipleContainer data-cy={props.dataCy}>
      <MultiSelect
        style={{fontSize: "100%"}}
        id={props.inputId}
        placeholder={props.placeholder}
        data={data}
        onChange={handleChange}
        value={props.values}
        textField={props.optionName}
        dataItemKey={props.dataItemKey}
        autoClose={false}
        disabled={props.disabled}
        filterable={true}
        onFilterChange={filterChange}
        loading={props.loading}
        tags={
          selected > 0
            ? [{ text: lang.qtySelectedItems(selected), data: [...props.values] }]
            : []
        }
      />
    </SelectMultipleContainer>
  );
};
